import { useCallback, useState } from 'react'
import { toast } from 'sonner'
import { useMallarFetch } from '@/hooks/useMallarFetch'
import getRouterBasename from '@/lib/router'

// Starts a Stripe Checkout for a template purchase and redirects to it.
// Mirrors the subscription checkout flow: the client computes the return URLs
// (so the SPA basename/origin is correct) and the backend uses them.
export function useMallarCheckout() {
  const apiFetch = useMallarFetch()
  const [pendingId, setPendingId] = useState<string | null>(null)

  const buyTemplate = useCallback(async (templateId: string) => {
    if (pendingId) return
    setPendingId(templateId)
    try {
      const base = `${window.location.origin}${getRouterBasename()}`
      const res = await apiFetch(`/api/templates/${templateId}/checkout`, {
        method: 'POST',
        body: JSON.stringify({
          success_url: `${base}/mallar?purchase=success&template=${templateId}`,
          cancel_url: `${base}/mallar?purchase=cancelled`,
        }),
      })
      if (res.status === 409) {
        toast.info('Du äger redan denna mall.')
        setPendingId(null)
        return
      }
      if (!res.ok) throw new Error(String(res.status))
      const { checkout_url } = await res.json()
      if (!checkout_url) throw new Error('no_url')
      window.location.replace(checkout_url) // leave the SPA → Stripe
    } catch {
      toast.error('Kunde inte starta köpet. Försök igen.')
      setPendingId(null)
    }
  }, [apiFetch, pendingId])

  return { buyTemplate, pendingId }
}